import { Close, Delete, Edit, More, Share } from "@mui/icons-material";
import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { Constant } from "../../../constant";
import { ConfirmAlert, NormalAlert } from "../../../export/AlertMessage";
import Service from "../../../service";
import BatteryGPS from "./BatteryGPS";

export default function PetitDetailGps({ details, close, retourModal, openAjoutModal }) {
  const [statusTrouver, setStatusTrouver] = useState({});
  const [spinner, setSpinner] = useState(false);
  const [more, setMore] = useState(false);

  useEffect(() => {
    let status = Constant.statusGps.find(a=>a.label === details.data.status)
    if(status === null || status === undefined) {
      status = Constant.statusGps.find(a=>a.label === Constant.offline)
    }
    setStatusTrouver(status)
  }, [details]);


  const MoreAction = () => {
    if(details.data.totalDistance !== undefined && details.data.totalDistance !== null){
      setMore(!more)
    }
  }
  const EditAction = () => {
    openAjoutModal(details.data)
  }
  const DeleteAction = () => {
    const message = `${Constant.fr.suppressionConfirmation}`
    const deleteFn = async() => {
        setSpinner(true)
        Service.deleteAll(Constant.paths.deleteGps, details.data.gps.id, true).then(
          reponse => {
            setSpinner(false)
            NormalAlert("success", reponse.data);
            retourModal(details.data, 2)
            close()
          },
          error => {
            setSpinner(false)
            if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
              NormalAlert("error", error.response.data.message);
            } else {
                NormalAlert("error", Constant.fr.erreurServeur);
            }
          }
        )
    }
    ConfirmAlert(message,  deleteFn)
  }
  const ShareAction = (latitude, longitude) => {
    if(details.data.totalDistance !== undefined && details.data.totalDistance !== null){
      const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
      window.open(url, "_blank");
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
     <div
        style={{
          position: "fixed",
          bottom: 20,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            width: more ? 400 : 250,
            backgroundColor: "white",
            borderLeft: "2px solid " + Constant.couleur.primary,
            borderRight: "2px solid " + Constant.couleur.primary,
            borderBottom: "2px solid " + Constant.couleur.primary,
            borderTop: "2px solid " + Constant.couleur.primary,
            borderRadius: 10,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          <div style={{padding: 10}}>
            <Row>
              <Col xs={22}>
                <strong style={{color: Constant.couleur.primary}}>{details.data.gps.nom}</strong>
              </Col>
              <Col xs={2} onClick={(e)=> {close(); setMore(false)}}>
                <Close style={{color: Constant.couleur.primary}}/>
              </Col>
              <Col xs={24} style={{borderBottom: "1px solid " + Constant.couleur.primary, paddingBottom: 5, marginBottom: 5}}>
                <p style={{fontSize: 11}}>{details.data.gps.contact}-<strong style={{color: statusTrouver.color}}>{statusTrouver.value}</strong></p>
              </Col>
              {/* vitesse */}
              {details.data.speed !== undefined && details.data.speed !== null &&
                  <>
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.Vitesse}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.speed.toFixed(2)} nd</p>
                    </Col>
                  </>
              }
              {/* Distance */}
              {details.data.totalDistance !== undefined && details.data.totalDistance !== null &&
                  <>
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.Distance}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.totalDistance.toFixed(2)} km</p>
                    </Col>
                  </>
              }
              {/* Orientation */}
                {details.data.course !== undefined && details.data.course !== null &&
                  <>
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.Orientation}</strong>
                    </Col>
                    <Col xs={12} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      {/* Flèche */}
                      <span
                        style={{
                          display: "inline-block",
                          transform: `rotate(${details.data.course || 0}deg)`,
                          fontSize: 18,
                        }}
                      >
                        ↑
                      </span>

                      {/* Valeur */}
                      <span style={{ fontSize: 12 }}>
                        {details.data.course}°
                      </span>

                    </Col>
                  </>
                }
    {/* Plus de detail */}
                {more &&
                  <>
                  {/* longitude */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.longitude}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.longitude}</p>
                    </Col>
                    {/* latitude */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.latitude}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.latitude}</p>
                    </Col>
                    {/* altitude */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.altitude}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.altitude}</p>
                    </Col>
                    {/* batteryLevel */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.batteryLevel}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.batteryLevel !== undefined && <BatteryGPS percent={details.data.batteryLevel} charging={false} />}</p>
                    </Col>
                    {/* fuelLevel */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.fuelLevel}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.fuelLevel}</p>
                    </Col>
                    {/* satellites */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.satellites}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.satellites}</p>
                    </Col>
                    {/* serverTime */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.serverTime}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{formatDate(details.data.serverTime)}</p>
                    </Col>
                    {/* deviceTime */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.deviceTime}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{formatDate(details.data.deviceTime)}</p>
                    </Col>
                    {/* accuracy */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.accuracy}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.accuracy}</p>
                    </Col>
                    {/* id */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.id}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.id}</p>
                    </Col>
                    {/* imei */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.imei}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.imei}</p>
                    </Col>
                    {/* protocole */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.protocole}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{fontSize: 12}}>{details.data.protocole}</p>
                    </Col>
                    {/* rawData */}
                    <Col xs={12}>
                      <strong style={{fontSize: 12}}>{Constant.fr.rawData}</strong>
                    </Col>
                    <Col xs={12}>
                      <p style={{
                        fontSize: 12,
                        display: "block",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal"
                        }}>{details.data.rawData}</p>
                    </Col>
                  </>
              }
                <Col xs={24}>
                    <div style={{backgroundColor: Constant.couleur.primary, borderRadius: 5}}>
                      <Row gutter={[16,16]}>
                        <Col xs={6}>
                          <div onClick={(e)=>MoreAction()} style={{textAlign: 'center', color: (details.data.totalDistance !== undefined && details.data.totalDistance !== null) ? 'white' : "black"}}>
                            <More style={{fontSize: 20, paddingTop: 3}}/>
                          </div>
                        </Col>
                          <Col xs={6} style={{borderLeft: "5px solid white"}}>
                            <div onClick={(e)=>EditAction()} style={{textAlign: 'center', color: 'white'}}>
                              <Edit style={{fontSize: 20, paddingTop: 3}}/>
                            </div>
                          </Col>
                          <Col xs={6} style={{borderLeft: "5px solid white"}}>
                            <div onClick={(e)=>DeleteAction()} style={{textAlign: 'center', color: 'white'}}>
                              <Delete style={{fontSize: 20, paddingTop: 3}}/>
                            </div>
                          </Col>
                          <Col xs={6} style={{borderLeft: "5px solid white"}}>
                            <div onClick={(e)=>ShareAction(details.data.latitude, details.data.longitude)} style={{textAlign: 'center', color: (details.data.totalDistance !== undefined && details.data.totalDistance !== null) ? 'white' : "black"}}>
                              <Share style={{fontSize: 20, paddingTop: 3}}/>
                            </div>
                          </Col>
                      </Row>
                    </div>
                </Col>
            </Row>
          </div>
        </div>
      </div>
  );
}

const styles = {
  headerContainer: {
    height: 52,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingBottom: 0,
  },
  headerText: {
    flex: 1,
    fontSize: 22,
    fontFamily: 'WorkSans-Bold',
    textAlign: 'center',
    textAlignVertical: 'center',
  },
  input: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 5,
    width: "100%"
  },
  formItemStyles: {
    margin: 0,
    padding: 0
  },
};